define('view/controller/booking/timezone/TimeZoneSelectDialogView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Time zone selection dialog
     *
     * @class TimeZoneSelectDialogView
     */
    return LayoutView.extend({

        template: '#timezone_select_dialog_view',
        ui: {
            cancelBtn: '#sb_cancel_button',
            setBtn: '#sb_set_button',
            timeZoneSelect: '#sb_timezone_select'
        },
        events: {
            'click @ui.setBtn': 'setTimeZone'
        },
        companyTimeZone: null,
        clientTimeZone: null,

        initialize: function (options) {
            this.collection = this.getOption('timeZoneCollection');

            if (this.collection.length === 0) {
                this.collection.fetch();
            }

            this.companyTimeZone = this.getOption('companyTimeZone');
            this.clientTimeZone = this.getOption('clientTimeZone');

            this.listenTo(this.collection, 'sync', this.render);
        },

        setTimeZone: function () {
            var selectedTz = this.collection.findWhere({
                id: this.ui.timeZoneSelect.val()
            });
            if (selectedTz) {
                this.model.set(selectedTz.toJSON());
                this.model.save();
            }
        },

        serializeData: function () {
            var result = Marionette.LayoutView.prototype.serializeData.apply(this);

            result.options = this.collection.toJSON();
            if (this.companyTimeZone) {
                result.current_time = this.companyTimeZone.getCurrentDateTime();
                
                result.current_company_time = this.companyTimeZone.getCurrentDateTime();
                result.company_time_zone = this.companyTimeZone.get('name');

                if (parseInt(Config.getInstance().getOption('show_booking_page_in_client_timezone'))) {
                    result.current_client_time = this.clientTimeZone.getCurrentDateTime();
                    result.client_time_zone = this.clientTimeZone.get('name');

                    result.show_client_time = true;
                }
            } else {
                result.current_time = new Date();
            }

            return result;
        }

    });

});
